import { FileEntryBM } from './fileEntry.types.js'

export interface IProduct {
  customerId: string
  stripeProductId: string
  type: ProductType
  title: string
  description: string
  slug: string
  images: FileEntryBM[]
  digitalAssets?: FileEntryBM[]
}

export interface ProductBM extends IProduct {
  _id: string
}

export interface ProductFM extends Omit<ProductBM, 'digitalAssets'> {
  priceSEK: number
  digitalAssets?: EcomDigitalAsset[]
}

export interface EcomDigitalAsset {
  fileEntryUuid: string
  name: string
  type: string
  presignedUrl?: string
}

export enum ProductType {
  DIGITAL_ASSET = 'DIGITAL_ASSET',
}

export interface ProductInput
  extends Omit<ProductFM, '_id' | 'customerId' | 'uuid' | 'stripeProductId'> {
  _id?: string
  stripeProductId?: string
}
